// The Shop Pay Installments banner's "Continue to checkout" opens a cart permalink for
// the main variant alone (shop-js constructCheckoutLink), which replaces the cart and
// drops the add-on lines Easify and TIGS add through the product form. Route the click
// through the page's own add to cart instead, then start Shop Pay from the cart.
const STORAGE_KEY = 'ig-shop-pay-installments';
const MAX_AGE_MS = 30000;

const root = () => window.Shopify?.routes?.root || '/';

// Easify and TIGS both act on the form's submit; a synthetic click on the button is
// ignored by Easify, so submit the form through its own submit button.
const addToCartForm = () => document.querySelector('form.js__form--addtocart');

const submitButton = (form) =>
    [...form.querySelectorAll('button[type="submit"], input[type="submit"]')].find(
        (button) => button.getClientRects().length
    );

const currentVariantId = (form) => Number(form.querySelector('[name="id"]')?.value) || null;

const remember = (payload) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
        console.error('Shop Pay Installments: session storage unavailable', error);
    }
};

const recall = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (error) {
        return null;
    }
};

const onClick = (event) => {
    const path = event.composedPath();
    const button = path.find((node) => node instanceof HTMLButtonElement);
    if (!button || !/continue to checkout/i.test(button.textContent || '')) return;
    if (!path.some((node) => node instanceof ShadowRoot)) return;
    if (!document.querySelector('shopify-payment-terms')) return;

    const form = addToCartForm();
    const submitter = form && submitButton(form);
    if (!submitter) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    remember({
        url: `${window.location.origin}${root()}checkout?payment=shop_pay_installments&source=installments_modal`,
        variantId: currentVariantId(form),
        t: Date.now(),
    });
    form.requestSubmit(submitter);
};

// Product page: send the modal's checkout click through add to cart.
export function interceptInstallmentsCheckout() {
    if (!document.querySelector('shopify-payment-terms')) return;
    document.addEventListener('click', onClick, true);
}

// Cart page: the add to cart flows all land here; continue to Shop Pay once.
export function continueInstallmentsCheckout() {
    const pending = recall();
    if (!pending || Date.now() - pending.t > MAX_AGE_MS) return;

    fetch(`${root()}cart.js?t=${Date.now()}`, { cache: 'no-store' })
        .then((response) => response.json())
        .then((cart) => {
            if (cart.items.some((item) => item.variant_id === pending.variantId)) {
                window.location.replace(pending.url);
            }
        })
        .catch((error) => console.error('Shop Pay Installments: cart check failed', error));
}
